import { render, staticRenderFns } from "./LeaderboardItem.vue?vue&type=template&id=30901360&scoped=true&lang=pug&"
import script from "./LeaderboardItem.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardItem.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardItem.vue?vue&type=style&index=0&id=30901360&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30901360",
  null
  
)

export default component.exports